export { default } from './ContentDescription';
